var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgComment = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "3p_FILL0_wght400_GRAD0_opsz48") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Offres-CnC",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Distribuer-Copy-5",
    transform: "translate(-36.000000, -487.000000)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    transform: "translate(30.000000, 234.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-10-Copy",
    transform: "translate(1.000000, 50.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "3p_FILL0_wght400_GRAD0_opsz48",
    transform: "translate(5.000000, 203.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.4,10.8 L12.6,10.8 L12.6,10.3725 C12.6,9.7425 12.28125,9.255 11.64375,8.91 C11.00625,8.565 10.125,8.3925 9,8.3925 C7.875,8.3925 6.99375,8.565 6.35625,8.91 C5.71875,9.255 5.4,9.7425 5.4,10.3725 L5.4,10.8 Z M9,6.9075 C9.465,6.9075 9.85875,6.74625 10.18125,6.42375 C10.50375,6.10125 10.665,5.7075 10.665,5.2425 C10.665,4.7775 10.50375,4.38375 10.18125,4.06125 C9.85875,3.73875 9.465,3.5775 9,3.5775 C8.535,3.5775 8.14125,3.73875 7.81875,4.06125 C7.49625,4.38375 7.335,4.7775 7.335,5.2425 C7.335,5.7075 7.49625,6.10125 7.81875,6.42375 C8.14125,6.74625 8.535,6.9075 9,6.9075 Z M0,18 L0,1.35 C0,1.005 0.135,0.69375 0.405,0.41625 C0.675,0.13875 0.99,0 1.35,0 L16.65,0 C16.995,0 17.30625,0.13875 17.58375,0.41625 C17.86125,0.69375 18,1.005 18,1.35 L18,13.05 C18,13.395 17.86125,13.70625 17.58375,13.98375 C17.30625,14.26125 16.995,14.4 16.65,14.4 L3.6,14.4 L0,18 Z M1.35,14.7375 L3.0375,13.05 L16.65,13.05 L16.65,1.35 L1.35,1.35 L1.35,14.7375 Z M1.35,1.35 L1.35,14.7375 L1.35,1.35 Z",
    id: "Shape"
  }))))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgComment);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/comment.1e234b1d547849df1facd278525c6b8b.svg";